import { takeLatest, call, put } from "redux-saga/effects";
import { apiUrl } from "../components/Config/config";
import { GET_ANNOUNCEMENT } from "../actions";
import cookie from "react-cookies";
import Axios from "axios";

export const watchGetAnnouncement = function*() {
  yield takeLatest(GET_ANNOUNCEMENT, workerGetAnnouncement);
};

function* workerGetAnnouncement(Param) {
  const result = yield call(getAnnouncement, Param);
  yield put({ type: "SET_ANNOUNCEMENT", json: result.data });
}

function getAnnouncement(Param) {
  const options = {
    headers: { Auth: cookie.load("user_details").token }
  };
  return Axios.get(apiUrl + "announcement/listannouncement", options).then(
    response => {
      return response;
    },
    error => {
      return { data: { status: error.response.data.status } };
    }
  );
}
